document.addEventListener('DOMContentLoaded', function() {
    var slider = tns({
        container: '.slider_img',
        items: 1,
        controls: false,
        slideBy: 'page',
        nav: false,
        autoplayButtonOutput: false,
        mouseDrag: true,
        autoplay: true,    
        responsive: {
          640: {
            items: 2
          },
          900: {
            items: 3
          }
        }
      });
});